import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import {
    Button, ButtonGroup, Col, Row,
} from 'react-bootstrap';
import ReactLoading from 'react-loading';
import ReactTable from 'react-table';

import Fetcher from '../common/communicate';
import debounce from '../tools/debounce';

export class DragTrComponent extends React.Component {
    render() {
        const { children = null, rowInfo } = this.props;

        if (rowInfo) {
            const { index, original } = rowInfo;
            const { id, priority } = original;

            return (
                <Draggable key={priority} index={index} draggableId={`${id}_${priority}`}>
                    {(draggableProvided) => (
                        <div
                            ref={draggableProvided.innerRef}
                            {...draggableProvided.draggableProps}
                            {...draggableProvided.draggableProps}
                            {...draggableProvided.dragHandleProps}
                        >
                            <ReactTable.defaultProps.TrComponent
                                style={{ width: '100%', borderBottom: '1px solid #dddddd' }}
                            >
                                {children}
                            </ReactTable.defaultProps.TrComponent>
                        </div>
                    )}
                </Draggable>
            );
        }

        return (
            <ReactTable.defaultProps.TrComponent>
                {children}
            </ReactTable.defaultProps.TrComponent>
        );
    }
}

export class DropTbodyComponent extends React.Component {
    render() {
        const { children = null } = this.props;

        return (
            <Droppable droppableId="droppable">
                {(droppableProvided) => (
                    <div ref={droppableProvided.innerRef}>
                        <ReactTable.defaultProps.TbodyComponent>
                            {children}
                            {droppableProvided.placeholder}
                        </ReactTable.defaultProps.TbodyComponent>
                    </div>
                )}
            </Droppable>
        );
    }
}

export class TableScreen extends React.Component {
    constructor(props) {
        super(props);
        this.columns = props.columns;
        this.API_ENDPOINT = props.endpoint;
        this.state = { loading: true, data: props.data, qs: {} };
        this.pageChange = this.pageChange.bind(this);
        this.handleData = this.handleData.bind(this);
        this.isGofProject = window.location.pathname.includes('gof.vkplay.ru') && window.location.pathname.includes('static');
    }

    debouncedFetcher = debounce((API_ENDPOINT) => {
        Fetcher(API_ENDPOINT, 'GET', this.handleData);
    }, 400);

    componentWillReceiveProps(nextProps) {
        this.setState({ loading: true });
        this.API_ENDPOINT = nextProps.endpoint;
        this.debouncedFetcher(this.API_ENDPOINT);
    }

    pageJump(page_num) {
        if (!page_num) {
            return;
        }

        const newQs = this.state.qs;
        newQs.page = page_num;
        this.setState({ qs: newQs });

        this.refreshData();
    }

    pageChange(evt) {
        if (evt.target.id) {
            this.pageJump(evt.target.id);
        }
    }

    sortChange(filtered) {
        let filter_by = filtered[0].id;

        if (filtered[0].desc) {
            filter_by = `-${filter_by}`;
        }

        const newQs = this.state.qs;
        newQs.ordering = filter_by;
        this.setState({ qs: newQs });

        this.refreshData();
    }

    refreshData() {
        let result_qs = '?';

        if (this.API_ENDPOINT.includes('?')) {
            result_qs = '';
        }

        for (let i = 0; i < Object.keys(this.state.qs).length; i++) {
            const key = Object.keys(this.state.qs)[i];
            result_qs += `&${key}=${this.state.qs[key]}`;
        }

        Fetcher(this.API_ENDPOINT + result_qs, 'GET', this.handleData);
    }

    handleData(data) {
        if (this.props.allowedCategory && this.isGofProject) {
            const results = data.results.filter((item) => item.slug.split('-').includes(this.props.allowedCategory));
            data.results = results;
        }

        this.setState({ loading: false, data });
    }

    componentDidMount() {
        Fetcher(this.API_ENDPOINT, 'GET', this.handleData);
    }

    getPaginator(current_page, total_pages, pageJump) {
        if (total_pages <= 1) {
            return;
        }

        const prevs_pages = [];
        const next_pages = [];

        // PREVS pages
        if (current_page >= 10) {
            prevs_pages.push(<Button key="first_page" id={1} onClick={pageJump}>{1}</Button>);
            prevs_pages.push(
                <Button key="left_chevron" id={(current_page - 10)} onClick={pageJump}>
                    <FontAwesomeIcon icon="chevron-left" />
                </Button>,
            );
        }

        if (current_page > 1) {
            for (let i = current_page - 9; i < current_page; i++) {
                if (i <= 0) {
                    continue;
                }

                prevs_pages.push(
                    <Button variant="outline-secondary" key={`prev_${i}`} id={i} onClick={pageJump}>{i}</Button>,
                );
            }
        }

        prevs_pages.push(<Button variant="secondary" key="current">{current_page}</Button>);
        // NEXT pages
        let max_pages = total_pages;

        if (total_pages > (current_page + 10)) {
            max_pages = current_page + 10;
        }

        for (let i = current_page + 1; i <= max_pages; i++) {
            next_pages.push(<Button
                variant="outline-secondary"
                key={`next_${i}`}
                id={i}
                onClick={pageJump}
            >
                {i}
            </Button>);
        }

        if (max_pages !== total_pages) {
            next_pages.push(<Button key="right_chevron" id={(current_page + 10)} onClick={pageJump}>
                <FontAwesomeIcon icon="chevron-right" />
            </Button>);
            next_pages.push(<Button key="total" id={total_pages} onClick={pageJump}>{total_pages}</Button>);
        }

        return (<ButtonGroup>{prevs_pages.concat(next_pages)}</ButtonGroup>);
    }

    getTrProps = (state, rowInfo) => ({ rowInfo });

    getResults(res) {
        const result_list = [];

        for (let i = 0; i < res.length; i++) {
            if (!res[i]) {
                continue;
            }

            result_list.push(res[i]);
        }

        return result_list;
    }

    getTable(draggable) {
        let page_size = this.state.data.results.length;

        if (page_size === 0) {
            page_size = 4;
        }

        if (draggable) {
            return (
                <DragDropContext onDragEnd={this.props.handleDragEnd}>
                    <ReactTable
                        TrComponent={DragTrComponent}
                        TbodyComponent={DropTbodyComponent}
                        getTrProps={this.getTrProps}
                        className="-highlight"
                        pageSize={page_size}
                        showPageSizeOptions={false}
                        showPagination={false}
                        data={this.getResults(this.state.data.results)}
                        columns={this.columns}
                        pages={this.state.data.total_pages}
                        onSortedChange={(filtered, column, shiftKey) => {
                            this.sortChange(filtered, column, shiftKey);
                        }}
                        noDataText="Нет данных"
                        onChange={this.props.onChange}
                        onFetchData={this.props.onFetchData}
                    />
                </DragDropContext>
            );
        }

        return (
            <ReactTable
                className="-highlight"
                pageSize={page_size}
                showPageSizeOptions={false}
                showPagination={false}
                data={this.getResults(this.state.data.results)}
                columns={this.columns}
                pages={this.state.data.total_pages}
                getTrProps={() => ({
                    style: {
                        borderBottom: '1px solid #dddddd',
                    },
                })}
                onSortedChange={(filtered, column, shiftKey) => {
                    this.sortChange(filtered, column, shiftKey);
                }}
                noDataText="Нет данных"
                onChange={this.props.onChange}
                onFetchData={this.props.onFetchData}
            />
        );
    }

    render() {
        if (this.state.loading) {
            return (
                <div>
                    <Row>
                        <Col md={{ offset: 4, span: 2 }}>
                            <ReactLoading type="bubbles" color="#aaaaaa" height={667} width={375} />
                        </Col>
                    </Row>
                </div>
            );
        }

        return (
            <div>
                {this.getTable(this.props.draggable)}
                {/* Custom paginator */}
                <Row>
                    <br />
                    <br />
                </Row>
                <Row className="show-grid">
                    <Col md={12}>
                        {this.getPaginator(this.state.data.current_page, this.state.data.total_pages, this.pageChange)}
                    </Col>

                </Row>
            </div>
        );
    }
}

export class TableScreenWithoutUpdate extends TableScreen {
    constructor(props) {
        super(props);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.loading) {
            return false;
        }

        return true;
    }
}

export class TableScreenStatic extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            current_page: props.current_page || 1,
            total_pages: props.total_pages || 1,
            columns: props.columns,
            data: props.data || [],
        };
    }

    sortChange() {
    }

    getTrProps = (state, rowInfo) => ({ rowInfo });

    getTable(draggable) {
        let page_size = this.props.data.length;

        if (page_size === 0) {
            page_size = 4;
        }

        if (draggable) {
            return (
                <DragDropContext onDragEnd={this.props.handleDragEnd}>
                    <ReactTable
                        TrComponent={DragTrComponent}
                        TbodyComponent={DropTbodyComponent}
                        getTrProps={this.getTrProps}
                        className="-highlight"
                        pageSize={page_size}
                        showPageSizeOptions={false}
                        showPagination={false}
                        data={this.props.data}
                        columns={this.props.columns}
                        pages={this.state.total_pages}
                        onSortedChange={(filtered, column, shiftKey) => {
                            this.sortChange(filtered, column, shiftKey);
                        }}
                        noDataText="Нет данных"
                    />
                </DragDropContext>
            );
        }

        return (
            <ReactTable
                className="-highlight"
                pageSize={page_size}
                showPageSizeOptions={false}
                showPagination={false}
                data={this.props.data}
                columns={this.props.columns}
                pages={this.state.total_pages}
                getTrProps={() => ({
                    style: {
                        borderBottom: '1px solid #dddddd',
                    },
                })}
                onSortedChange={(filtered, column, shiftKey) => {
                    this.sortChange(filtered, column, shiftKey);
                }}
                noDataText="Нет данных"
            />
        );
    }

    pageJump(page_num) {
        this.page_change_handler(page_num);
    }

    paginator() {
        const prevs_pages = [];
        const next_pages = [];

        if (this.state.total_pages <= 1) {
            return;
        }

        if (this.state.current_page > 10) {
            prevs_pages.push(<Button key="first_page" id={1} onClick={this.pageJump}>{1}</Button>);
            prevs_pages.push(
                <Button key="left_chevron" id={(this.state.current_page - 10)} onClick={this.pageJump}>
                    <FontAwesomeIcon icon="chevron-left" />
                </Button>,
            );
        }

        prevs_pages.push(<Button variant="secondary" key="current">{this.state.current_page}</Button>);

        let max_pages = this.state.total_pages;

        if (max_pages > (this.state.current_page + 10)) {
            max_pages = this.state.current_page + 10;
        }

        for (let i = this.state.current_page + 1; i <= max_pages; i++) {
            next_pages.push(<Button
                variant="outline-secondary"
                key={`next_${i}`}
                id={i}
                onClick={this.pageJump}
            >
                {i}
            </Button>);
        }

        if (max_pages !== this.state.total_pages) {
            next_pages.push(<Button key="right_chevron" id={(this.state.current_page + 10)} onClick={this.pageJump}>
                <FontAwesomeIcon icon="chevron-right" />
            </Button>);
            next_pages.push(<Button key="total" id={this.state.total_pages} onClick={this.pageJump}>{this.state.total_pages}</Button>);
        }

        return (<ButtonGroup>{prevs_pages.concat(next_pages)}</ButtonGroup>);
    }

    render() {
        return (
            <div>
                {this.getTable(this.props.draggable)}
                <Row>
                    <br />
                    <br />
                </Row>
                <Row className="show-grid">
                    <Col md={12}>
                        {this.paginator()}
                    </Col>

                </Row>
            </div>
        );
    }
}
